import { faAddressCard, faCommentDots, faEyeSlash, faKey, faScreenUsers, faXmarkLarge } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';

const StudentList = ({student, onAction, allowedToEdit, displayUserPasswords, preventChangePassword, ferpaEnabled, isDistrictManaged}) =>
{
  return(
    <>
      <td>{ferpaEnabled?student.lName: <i>Hidden</i>}</td>
      <td>{ferpaEnabled?student.fName: <i>Hidden</i>}</td>
      <td>{ferpaEnabled?student.identification: <i>ID Hidden</i>}</td>
      <td>{ferpaEnabled?student.login: <i>Login Hidden</i>}</td>
      <td className='d-none column-to-show text-center'>{student.code}</td>
      <td className='min-w-150 column-to-hide'>
        {student.password && student.password.length>0 && 
        <div className='d-flex'>
          <OverlayTrigger
            key="viewPassword"
            placement="top"
            overlay={<Tooltip className="custom-tooltip">View Password</Tooltip>}>
            <button
              id={'viewPassword' + student.id}
              className="btn grid-icon-btn info-icon-btn mr-2"
              hidden={!displayUserPasswords}
              onClick={() => onAction('ViewPassword', student)}
            >
              <FontAwesomeIcon icon={faKey} />
            </button>
          </OverlayTrigger>

          <OverlayTrigger
            key="clearPassword"
            placement="top"
            overlay={<Tooltip className="custom-tooltip">
              {preventChangePassword && <span>Passwords are pre set by the destrict and cannot be cleared.
                <br/>
                  Please contact your Administrator if you need further assistance
              </span>}
              {!preventChangePassword && <span>Clear Password</span> }
            </Tooltip>}>
            <div>
              <button
                id={'clearPassword' + student.id}
                className="btn grid-icon-btn info-icon-btn"
                disabled={!allowedToEdit || preventChangePassword}
                onClick={() => onAction('ClearPassword', student)}
              >
                <FontAwesomeIcon icon={faXmarkLarge} />
              </button>
            </div>
          </OverlayTrigger>
        </div>}
        {(!student.password || student.password.length == 0)
          && <span>Not Set</span>
        }
      </td>
      <td className='min-w-150 column-to-hide'>
        {!student.deleted && <>
          <OverlayTrigger
            key="move"
            placement="top"
            overlay={<Tooltip className="custom-tooltip">Move to another class</Tooltip>}>
            <button
              id={'move' + student.id}
              className="btn grid-icon-btn info-icon-btn mr-2"
              disabled={!allowedToEdit || isDistrictManaged}
              onClick={() => onAction('Move', student)}
            >
              <FontAwesomeIcon icon={faScreenUsers} />
            </button>
          </OverlayTrigger>

          <OverlayTrigger
            key="hide"
            placement="top"
            overlay={<Tooltip className="custom-tooltip">Hide
            </Tooltip>}>
            <button
              id={'hide' + student.id}
              className="btn grid-icon-btn info-icon-btn mr-2"
              disabled={!allowedToEdit || isDistrictManaged}
              onClick={() => onAction('Hide', student)}
            >
              <FontAwesomeIcon icon={faEyeSlash} />
            </button>
          </OverlayTrigger>

          <OverlayTrigger
            key="idCard"
            placement="top"
            overlay={<Tooltip className="custom-tooltip">Print ID Card</Tooltip>}>
            <button
              id={'idCard' + student.id}
              className="btn grid-icon-btn info-icon-btn mr-2"
              onClick={() => onAction('PrintIDCards', student)}
            >
              <FontAwesomeIcon icon={faAddressCard} />
            </button>
          </OverlayTrigger>

          <OverlayTrigger
            key="sendMessage"
            placement="top"
            overlay={<Tooltip className="custom-tooltip">Send Message</Tooltip>}>
            <button
              id={'sendMessage' + student.id}
              className="btn grid-icon-btn info-icon-btn"
              onClick={() => onAction('SendMessage', student)}
            >
              <FontAwesomeIcon icon={faCommentDots} />
            </button>
          </OverlayTrigger>
        </>
        }
      </td>
    </>
  );
};

StudentList.propTypes={
  student : PropTypes.array.isRequired,
  onAction : PropTypes.func.isRequired,
  allowedToEdit : PropTypes.bool.isRequired,
  preventChangePassword : PropTypes.bool.isRequired,
  displayUserPasswords : PropTypes.bool.isRequired,
  ferpaEnabled : PropTypes.bool.isRequired,
  isDistrictManaged : PropTypes.bool.isRequired
};

export default StudentList;

